import { AlertDialog, AlertDialogHeader, AlertDialogOverlay, AlertDialogContent, AlertDialogBody, AlertDialogFooter, Button, ButtonGroup } from "@chakra-ui/react";
import { FC, useRef } from "react";
import { useRunSync, useToastNotification } from "lib/hooks";
import { packsClient } from "lib/clients";

type Props = {
  title: string;
  content: string;
  isOpen: boolean;
  onClose: () => void;
  asset: any;
}

export const DeleteAlertDialog: FC<Props> = ({ asset, title, content, onClose, isOpen, ...rest }) => {
  const cancelRef = useRef();
  const { sync } = useRunSync(asset?.pack_id);
  const { errorToast, successToast } = useToastNotification();

  const onDelete = async (): Promise<void> => {
    try {
      await packsClient.deleteAsset(asset.pack_id, asset.id);
      await sync();
      successToast({ title: 'Success', description: 'The selected asset has been deleted.' });
    } catch (e) {
      errorToast({ title: 'Error', description: 'Could not delete asset, please try again.' });
    }

    onClose();
  }

  return (
    <AlertDialog motionPreset="slideInBottom" leastDestructiveRef={cancelRef} onClose={onClose} isOpen={isOpen} isCentered {...rest}>
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader marginBottom={-1}>{ title }</AlertDialogHeader>
        <AlertDialogBody>
          { content }
        </AlertDialogBody>
        <AlertDialogFooter>
          <ButtonGroup>
            <Button variant="cancel" ref={cancelRef} onClick={onClose}>Cancel</Button>
            <Button variant="destructive" onClick={onDelete}>Delete</Button>
          </ButtonGroup>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
};
